export var webExclusivePackageName = "webExclusive";
export var webExclusiveProfilePicturePackageId = 278;



//////////////////
// WEBPACK FOOTER
// ./src/constants/webExclusives.ts
// module id = 566
// module chunks = 3